import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Select from "react-dropdown-select";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import ReactTelInput from "react-telephone-input";
import * as Yup from "yup";
import "yup-phone-lite";
import "../../../../css/tel.css";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";
import { Tracker } from "../../../util/analytics";
import { getUser } from "../../../util/helpers";
import * as auth from "../_redux/authRedux";

const initialValues = {
  first_name: "",
  business_email: "",
  last_name: "",
  phone_number: "+91",
  phone_number2: "+91",
  country_code: "in",
  employee_count: "",
  city: "",
  product: "",
};

function StartFreeTrial(props) {
  // useEffect(() => {
  //   Tracker.event("AUTH", "start-free-trial","Start Free Trial Clicked"
  //   ,"start-free-trial-clicked",{'user':getUser()})
  // },[]);

  const [show, setShow] = useState(false);
  const submitRef = React.useRef(null);

  const handleClose = () => {
    formik.resetForm();
    setShow(false);
  };
  const handleShow = () => {
    Tracker.event(
      "AUTH",
      "start-free-trial",
      "Start Free Trial Clicked",
      "start-free-trial-clicked",
      { user: getUser() }
    );
    setShow(true);
  };

  const productOptions = [
    { label: "Voice Solution", value: "Voice-Solution" },
    { label: "Speech Analytics", value: "Speech-Analytics" },
    { label: "Video Platform", value: "Video Platform" },
    { label: "ChatBots/VoiceBots", value: "ChatBots/VoiceBots" },
    { label: "Text to Speech", value: "Text to Speech" },
    { label: "Messaging Solution", value: "Messaging Solution" },
  ];

  const employeeOptions = [
    { label: "0 - 24", value: "0 - 24" },
    { label: "25 - 49", value: "25 - 49" },
    { label: "50 - 99", value: "50 - 99" },
    { label: "100 - 199", value: "100 - 199" },
    { label: "200 - 499", value: "200 - 499" },
    { label: "500 - 1999", value: "500 - 1999" },
    { label: "2000+", value: "2000+" },
  ];

  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const RegistrationSchema = Yup.object().shape({
    first_name: Yup.string()
      .min(1, "Please enter a First Name")
      .required("Please enter a First Name"),
    last_name: Yup.string()
      .min(1, "Please enter a Last Name")
      .required("Please enter a Last Name"),
    phone_number2: Yup.string()
      .phone()
      .required("Please enter a Mobile Number."),
    business_email: Yup.string()
      .email("Invalid Email Id")
      .required("Invalid Email Id"),
    city: Yup.string()
      .min(1, "Please enter a city")
      .required("Please enter a city"),
    employee_count: Yup.string()
      .min(1, "Please Select A value")
      .required("Please Select A value"),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "";
    }
    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: RegistrationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setSubmitting(true);
      enableLoading();
      const params = {
        debug: 1,
        debugEmail: "adventz77@gmail.com",
        oid: "00D5g00000A32Za",
        retURL: "http://",
        phone: values["phone_number"],
        first_name: values["first_name"],
        last_name: values["last_name"],
        email: values["email"],
        city: values["city"],
        "00N2w00000JBv4Q": values["employee_count"],
        product: values["product"] ? values["product"] : "",
      };

      const form = new FormData();
      Object.keys(params).map((key) => {
        form.append(key, params[key]);
      });

      submitRef.current.click();

      Tracker.event(
        "AUTH",
        "start-free-trial",
        "Start Free Trial Submitted",
        "start-free-trial-submitted",
        params
      );
      return;
    },
  });

  const [telTouched, setTelTouched] = useState(false);
  function handleInputChange(telNumber, selectedCountry) {
    if (telTouched) {
      formik.setFieldTouched("phone_number", true, telTouched);
    }
    if (selectedCountry.iso2 != formik.values.country_code) {
      telNumber = "+" + selectedCountry.dialCode;
    }

    formik.setFieldValue("country_code", selectedCountry.iso2);
    formik.setFieldValue("phone_number", telNumber, telTouched);
    if (telTouched) {
      formik.setFieldTouched("phone_number", true, telTouched);
      formik.setFieldTouched("phone_number2", true, telTouched);
      formik.validateForm();
    }
    formik.setFieldValue("country_code", selectedCountry.iso2);
    formik.setFieldValue("phone_number", telNumber, telTouched);
    formik.setFieldValue("phone_number2", telNumber, telTouched);
    if (telTouched) {
      formik.setFieldTouched("phone_number2", true, true);
      formik.setFieldTouched("phone_number", true, true);
      formik.validateForm();
    }
    setTimeout(() => {
      if (telTouched) {
        formik.setFieldTouched("phone_number2", true, true);
        formik.setFieldTouched("phone_number", true, true);
        formik.validateForm();
      }
    }, 400);
  }
  function valTel() {
    formik.setFieldTouched("phone_number", true, true);
    formik.setFieldTouched("phone_number2", true, true);
    setTelTouched(true);
  }

  return (
    <>
      <a
        href="/#"
        onClick={(e) => {
          e.preventDefault(e);
          handleShow();
        }}
        className="link-clr"
        id="kt_login_signupdd"
      >
        <FormattedMessage
          id="Auth_general-free-trial"
          defaultMessage="Start Free Trial"
        />
      </a>

      <Modal
        dialogClassName="modal-90w free-trial-modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <div className="text-center">
            <Modal.Title>
              Great ! We need a few more details to activate your{" "}
              <span class="trial_prim">7 Days Free Trial</span>
            </Modal.Title>
          </div>
          <button
            className="link-button lgn-ovr-closebtn "
            onClick={handleClose}
          >
            <img
              alt=""
              src={toAbsoluteUrl("/media/sr/icons/cross_arrow.svg")}
              className="overlay-cross-icon"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <form
            id="kt_sslogin_signin_form"
            className="form fv-plugins-bootstrap start_trial"
            onSubmit={formik.handleSubmit}
          >
            <fieldset disabled={formik.isSubmitting || loading}>
              <div className="form-group fv-plugins-icon-container">
                <label for="phone_number">Phone Number *</label>
                <ReactTelInput
                  defaultCountry="in"
                  flagsImagePath="/media/sr/flags.png"
                  onChange={handleInputChange}
                  onBlur={valTel}
                  pattern22={
                    formik.values.country_code == "in" ? "[7-9]{1}[0-9]{9}" : ""
                  }
                  inputProps={{
                    name: "phone_number",
                    value: formik.values.phone_number,
                  }}
                  className22={`form-control form-control-soliddd h-auto py-3 px-6 ${getInputClasses(
                    "phone_number"
                  )}`}
                />
                {telTouched && formik.errors.phone_number2 ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.values.country_code == "in"
                        ? "Mobile Number must be 10 digits"
                        : "Invalid Mobile Number"}
                    </div>
                  </div>
                ) : null}
                <input
                  onChange={valTel}
                  type="hidden"
                  name="phone_number2"
                  value={formik.values.phone_number2}
                />
              </div>
              <div className="form-group fv-plugins-icon-container row">
                <div className="form-group col-lg-6 mt-1dd">
                  <label for="phone_number">First Name *</label>
                  <input
                    placeholder="First Name"
                    type="text"
                    className={`form-control form-control-soliddd h-auto py-3 px-6 ${getInputClasses(
                      "first_name"
                    )}`}
                    name="first_name"
                    {...formik.getFieldProps("first_name")}
                  />
                  {formik.touched.first_name && formik.errors.first_name ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.first_name}
                      </div>
                    </div>
                  ) : null}
                </div>

                <div className="form-group col-lg-6 mt-1dd">
                  <label for="last_name">Last Name *</label>
                  <input
                    placeholder="Last name"
                    type="text"
                    className={`form-control form-control-soliddd h-auto py-3 px-6 ${getInputClasses(
                      "last_name"
                    )}`}
                    name="last_name"
                    {...formik.getFieldProps("last_name")}
                  />
                  {formik.touched.last_name && formik.errors.last_name ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.last_name}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="form-group fv-plugins-icon-container">
                <label for="business_email">Business Email *</label>
                <input
                  placeholder="Business Email"
                  type="text"
                  className={`form-control form-control-soliddd h-auto py-3 px-6 ${getInputClasses(
                    "business_email"
                  )}`}
                  name="business_email"
                  {...formik.getFieldProps("business_email")}
                />
                {formik.touched.business_email &&
                formik.errors.business_email ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.business_email}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="form-group row">
                <div className="mb-4 mb-lg-0 col-lg-6">
                  <label for="employee_count">Employee Count *</label>
                  <Select
                    className="employee_count custom-select-optn"
                    options={employeeOptions}
                    placeholder="-- None --"
                    values={[]}
                    disabled={formik.isSubmitting || loading}
                    onChange={(value) =>
                      formik.setFieldValue("employee_count", value)
                    }
                  />
                  {formik.touched.employee_count &&
                  formik.errors.employee_count ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">
                        {formik.errors.employee_count}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="mb-4 mb-lg-0 col-lg-6">
                  <label for="city">City *</label>
                  <input
                    placeholder="City"
                    type="text"
                    className={`form-control form-control-soliddd h-auto py-3 px-6 ${getInputClasses(
                      "city"
                    )}`}
                    name="city"
                    {...formik.getFieldProps("city")}
                  />
                  {formik.touched.city && formik.errors.city ? (
                    <div className="fv-plugins-message-container">
                      <div className="fv-help-block">{formik.errors.city}</div>
                    </div>
                  ) : null}
                </div>
              </div>

              <Form.Row>
                <Form.Group as={Col} className="mb-1">
                  <div className="w-100">
                    <label htmlFor="product-options" className="trial-label">
                      Product
                    </label>
                  </div>
                  <div className="w-100 trial-multi-select">
                    <Select
                      className="product-select custom-select-optn"
                      options={productOptions}
                      values={[]}
                      disabled={formik.isSubmitting || loading}
                      onChange={(value) =>
                        formik.setFieldValue("product", value)
                      }
                    />
                  </div>
                </Form.Group>
              </Form.Row>

              {formik.status && (
                <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold">
                    {formik.status}
                  </div>
                </div>
              )}
            </fieldset>

            <div className="trial-btn-sec">
              <button
                onClick={() => {
                  formik.setFieldTouched("city", true, true);
                  formik.setFieldTouched("employee_count", true, true);
                  formik.submitForm();
                }}
                type="button"
                style={{ marginTop: "5px" }}
                disabled={formik.isSubmitting}
                className="sbt-btn"
                size="lg"
              >
                <span>Submit</span>
                {loading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>
            </div>

            <small>
              By submitting the form, you will be eligible for receiving the
              newsletter, and product & services update from Knowlarity
              Communications Pvt. Ltd.
            </small>
          </form>

          <form
            style={{ display: "none" }}
            action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
            method="POST"
          >
            <input type="hidden" name="oid" value="00D2w000008ohAc" />
            <input
              type="hidden"
              name="retURL"
              value={`${process.env.REACT_APP_FREE_TRIAL_REDIRECT_URL}/thankyou`}
            />
            <input type="hidden" name="lead_source" value="Organic" />
            <input type="hidden" name="00N2w00000JBtyv" value="Website" />
            <input
              type="hidden"
              name="00N2w00000JBv4l"
              value="http://Facebook.com"
            />

            <label for="first_name">First Name</label>
            <input
              value={formik.values.first_name}
              maxlength="40"
              name="first_name"
              size="20"
              type="text"
            />
            <br />

            <label for="last_name">Last Name</label>
            <input
              value={formik.values.last_name}
              maxlength="80"
              name="last_name"
              size="20"
              type="text"
            />
            <br />

            <label for="email">Email</label>
            <input
              value={formik.values.business_email}
              maxlength="80"
              name="email"
              size="20"
              type="text"
            />
            <br />

            <label for="phone">Phone</label>
            <input
              value={formik.values.phone_number}
              maxlength="40"
              name="phone"
              size="20"
              type="text"
            />
            <br />
            <label for="phone">Employees in the Organisation:</label>
            <input
              value={formik.values.employee_count}
              maxlength="40"
              name="00N2w00000JBv4Q"
              size="20"
              type="text"
            />
            <br />

            <br />

            <label for="city">City</label>
            <input
              value={formik.values.city}
              maxlength="40"
              name="city"
              size="20"
              type="text"
            />
            <br />

            <input type="submit" name="submit" ref={submitRef} />
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(StartFreeTrial));
